// extracted by mini-css-extract-plugin
module.exports = {"mediaBlock":"MediaBlock_mediaBlock__x1svK","placeholder":"MediaBlock_placeholder__ZlJwC"};